export default "__VITE_ASSET__CXTBz68k__"